<div (click)="toggleSidebar.emit()">
  <a
    class="sidebartoggler"
    href="javascript:void(0)">
    <em class="icon-menu"></em>
  </a>
</div>
